import React from 'react';
import TabNavigation from '../../Components/common/TabNavigation';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Profiles.css';
import '../Summary/Summary.css';
import ProfileFilters from './ProfileFilters';
import ProfileUsersTable from './ProfileUsersTable';
import ProfilePagination from './ProfilePagination';
import { useProfilePage } from './useProfilePage';

const Profile: React.FC = () => {
    const page = useProfilePage();

    return (
        <div className="plant-list-container">
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 10002 }}
            />
            <TabNavigation tabs={page.tabConfig} className="tabs-plants" />
            <ProfileFilters
                searchText={page.searchText}
                onSearchChange={page.handleSearch}
                customers={page.customers}
                selectedCustomerId={page.selectedCustomerId}
                isCustomerOpen={page.isCustomerOpen}
                customerSearch={page.customerSearch}
                filteredCustomersList={page.filteredCustomersList}
                onCustomerOpenToggle={page.toggleCustomerDropdown}
                onCustomerSearchChange={page.setCustomerSearch}
                onCustomerSelect={page.handleCustomerSelect}
                selectedUserType={page.selectedUserType}
                isUserTypeOpen={page.isUserTypeOpen}
                userTypeSearch={page.userTypeSearch}
                filteredUserTypesList={page.filteredUserTypesList}
                onUserTypeOpenToggle={page.toggleUserTypeDropdown}
                onUserTypeSearchChange={page.setUserTypeSearch}
                onUserTypeSelect={page.handleUserTypeSelect}
                onDownload={page.handleDownload}
                onAddUser={page.handleAddUser}
                btnDisabled={page.btnDisabled}
            />
            <ProfileUsersTable
                isLoadingProfile={page.isLoadingProfile}
                paginatedProfiles={page.paginatedProfiles}
                sortConfig={page.sortConfig}
                onRequestSort={page.requestSort}
                onProfileClick={page.handleProfileClick}
            />
            <ProfilePagination
                currentPage={page.currentPage}
                totalPages={page.totalPages}
                totalItems={page.totalItems}
                itemsPerPage={page.itemsPerPage}
                onPrevious={page.handlePreviousPage}
                onNext={page.handleNextPage}
            />
        </div>
    );
};

export default Profile;
